import React from "react";

const ColorModeContext = React.createContext({
    toggleColorMode: () => { },
    setPrimaryColorLight: (_) => { },
    setPrimaryColorDark: (_) => { },
    setSidebarTextColorLight: (_) => { },
    setAppLogoLight: (_) => { },
    setAppLogoDark: (_) => { },
    setAppLogoLoginLight: (_) => { },
    setAppLogoLoginDark: (_) => { },
    setAppSidebarIconLight: (_) => { },
    setAppSidebarIconDark: (_) => { },
    setAppLogoFavicon: (_) => { },
});

export default ColorModeContext;
